export function ensureArray<T>(value: unknown): T[] {
  if (Array.isArray(value)) {
    return value as T[]
  }

  if (typeof value === "string" && value.length > 0) {
    return [value as T]
  }

  return []
}
